<div class="complaints-container">
  <main class="complaints-main">
    <div class="complaints-card">
      <div class="card-header">
        <h2 class="card-title">COMPLAINTS</h2>
        @if (canCreateComplaint) {
          <button
            class="btn-new-complaint"
            (click)="createNewComplaint()">
            <i class="fa fa-plus"></i>
            New Complaint
          </button>
        }
      </div>

      <div class="card-body">
        <aside class="complaints-sidebar">
          <div class="sidebar-section">
            <h3 class="sidebar-title">TICKETS</h3>

            <div class="status-filters">
              @for (status of statusFilters; track status) {
                <button
                  class="status-filter-btn"
                  [class.active]="selectedStatus === status.key"
                  (click)="selectStatus(status.key)">
                  <i class="fa" [ngClass]="status.icon"></i>
                  <span>{{ status.label }}</span>
                  @if (status.count && status.count > 0) {
                    <span class="status-count">{{ status.count }}</span>
                  }
                </button>
              }
            </div>
          </div>

          <div class="sidebar-section detail-filters">
            <h3 class="sidebar-title">DETAIL FILTER</h3>

            <div class="filter-group">
              <select-field
                label="Priority"
                [options]="priorityOptions"
                [selectFormControl]="priorityControl">
              </select-field>
            </div>

            <div class="filter-group">
              <select-field
                label="Category"
                [options]="categoryOptions"
                [selectFormControl]="categoryControl">
              </select-field>
            </div>

            <div class="filter-group">
              <input-field
                label="From"
                type="date"
                [inputFormControl]="fromControl">
            </input-field>
          </div>

          <div class="filter-group">
            <input-field
              label="To"
              type="date"
              [inputFormControl]="toControl">
          </input-field>
        </div>

        <button class="clear-filters-btn" (click)="clearDetailFilters()">
          Clear Filters
        </button>
      </div>
    </aside>

    <div class="complaints-list-wrapper">
      <div class="list-header">
        <h3 class="list-title">Complaints list</h3>
        <div class="search-box">
          <i class="fa fa-search"></i>
          <input
            type="text"
            class="search-input"
            placeholder="Search..."
            [(ngModel)]="searchTerm"
            (keyup.enter)="onSearchChange()">
        </div>
      </div>

      <div class="complaints-list">
        @for (complaint of complaints; track complaint) {
          <div
            class="complaint-item"
            (click)="viewComplaint(complaint.complaintId)">
            <div class="complaint-icons">
              <span class="country-flag">
                <img
                  [src]="'assets/flags/' + complaint?.customerPerson?.customer?.language?.iso2.toLowerCase() + '.svg'"
                  [alt]="complaint?.customerPerson?.customer?.language?.iso2"
                  onerror="this.style.display='none'">
              </span>
              <i class="fa complaint-icon" [ngClass]="getStatusIcon(complaint?.status)"></i>
              <span class="complaint-color-box" [ngClass]="getPriorityColorClass(complaint?.priority)"></span>
            </div>
            <div class="complaint-info">
              <div class="complaint-from">
                <strong>From:</strong> {{ complaint?.customerPerson?.customer?.companyName }}
                <span class="complaint-person">({{ complaint?.customerPerson?.firstName }} {{ complaint?.customerPerson?.lastName }})</span>
              </div>
              <div class="complaint-code">
                <em class="me-2">{{ complaint?.code }}</em> {{ complaint?.summary }}
              </div>
            </div>
            <div class="complaint-category">
              <strong>Category:</strong> {{ complaint?.complaintCategory?.name }}
            </div>
            <div class="complaint-assigned">
              <i class="fa" [ngClass]="hasTakingCareUser(complaint) ? 'fa-user' : 'fa-user-times'"></i>
              @if (hasTakingCareUser(complaint)) {
                <span>{{ getAssignedToFullName(complaint) }}</span>
              }
            </div>
            <div class="complaint-actions">
              <i class="fa fa-calendar action-icon"></i>
            </div>
            <div class="complaint-date">
              <i class="fa fa-calendar-alt"></i>
              {{ complaint?.createTime | date:'dd MMM' }}
            </div>
            <div class="complaint-status">
              <span
                class="status-indicator"
                [ngClass]="getStatusClass(complaint?.reminderStatus)">
              </span>
            </div>
          </div>
        }
        @if (complaints.length === 0) {
          <div class="empty-list">
            <i class="fa fa-inbox"></i>
            <p>No complaints found</p>
          </div>
        }
      </div>

      @if (totalPages > 0) {
        <div class="row justify-content-between align-items-center mt-3">
          <div class="col-sm-12 col-md-5">
            @if (totalElements > 0) {
              <div class="text-muted small">
                Showing <strong>{{ currentPage * pageSize + 1 }}</strong> to
                <strong>{{ Math.min((currentPage + 1) * pageSize, totalElements) }}</strong>
                of <strong>{{ totalElements }}</strong> entries
              </div>
            }
          </div>
          <div class="col-sm-12 col-md-7">
            <div class="dataTables_paginate paging_simple_numbers">
              <ul class="pagination pagination-sm justify-content-end mb-0 primary-pagination">
                <li class="paginate_button page-item previous" [ngClass]="{ 'disabled': currentPage === 0 }">
                  <a aria-controls="complaints-pagination" data-dt-idx="0" tabindex="0" class="page-link"
                  (click)="changePage(currentPage - 1)">Back</a>
                </li>
                @if (!shouldUseCompactPagination()) {
                  @for (page of getAllPages(); track page) {
                    <li class="paginate_button page-item"
                      [ngClass]="{ 'active': page === currentPage }">
                      <a aria-controls="complaints-pagination" tabindex="0" class="page-link" (click)="changePage(page)">{{ page + 1 }}</a>
                    </li>
                  }
                }
                @if (shouldUseCompactPagination()) {
                  <li class="paginate_button page-item" [ngClass]="{ 'active': currentPage === 0 }">
                    <a aria-controls="complaints-pagination" tabindex="0" class="page-link" (click)="changePage(0)">1</a>
                  </li>
                  @if (getVisiblePages().length > 0 && getVisiblePages()[0] > 1) {
                    <li class="paginate_button page-item disabled">
                      <a aria-controls="complaints-pagination" tabindex="-1" class="page-link">...</a>
                    </li>
                  }
                  @for (page of getVisiblePages(); track page) {
                    <li class="paginate_button page-item"
                      [ngClass]="{ 'active': page === currentPage }">
                      <a aria-controls="complaints-pagination" tabindex="0" class="page-link" (click)="changePage(page)">{{ page + 1 }}</a>
                    </li>
                  }
                  @if (getVisiblePages().length > 0 && getVisiblePages()[getVisiblePages().length - 1] < totalPages - 2) {
                    <li
                      class="paginate_button page-item disabled">
                      <a aria-controls="complaints-pagination" tabindex="-1" class="page-link">...</a>
                    </li>
                  }
                  @if (totalPages > 1) {
                    <li
                      class="paginate_button page-item" [ngClass]="{ 'active': currentPage === totalPages - 1 }">
                      <a aria-controls="complaints-pagination" tabindex="0" class="page-link"
                      (click)="changePage(totalPages - 1)">{{ totalPages }}</a>
                    </li>
                  }
                }
                <li class="paginate_button page-item next"
                  [ngClass]="{ 'disabled': currentPage === totalPages - 1 }">
                  <a aria-controls="complaints-pagination" tabindex="0" class="page-link"
                  (click)="changePage(currentPage + 1)">Forward</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
</main>
</div>
